<template>
  <div>
    <v-dialog v-model="dialog.login"
      @keydown.esc="dialog.login = false"
      width="400"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
        <v-card-text 
          class="py-0 my-4">
          <div
            class="d-flex align-center mb-2" style="justify-content: center;">
            <v-avatar
              tile
              size="100">
              <v-img
                contain
                alt="diskominfo"  
                :src="require('@/assets/icon/info_warning.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>
          </div>
          Maaf, login SSO Anda gagal di lakukan, silahkan klik tombil di bawah untuk melakukan login ulang
        </v-card-text>
        
        <v-divider 
          class="mt-2"
          style="border-top: 2px dashed #e0e0e0;"/>

        <v-card-actions
          class="pa-4">
          <v-spacer/>

          <v-btn
            @click="toLogin()"
            width="120"
            elevation="0"
            color="green"
            rounded
            class="body-2 font-weight-bold text-capitalize white--text">
            Login
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card
      flat
      min-height="100vh"
      class="d-flex align-center"
      style="z-index: 1;">
      <v-card-text>
        <div
          class="text-h5 text-center font-weight-bold mb-2"
          :style="`color: ${set_color};`">
          Login SSO sedang dilakukan 
        </div>

        <!-- <div
          class="body-1 text-center">
          Tiket Pariwisata Disbudporapar
        </div> -->

        <div
          class="body-1 text-center mt-2">
          Mohon tunggu beberapa saat
        </div>

        <div
          class="d-flex justify-center ma-6">
          <!-- <v-progress-linear
            indeterminate
            height="8"
            rounded
            class="loader"
            :color="set_color">
          </v-progress-linear> -->
          <v-progress-circular
            :size="50"
            :color="set_color"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
  
  
  <script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
    export default {
      data () {
        return {
          selected: {
            menu: 0
          },
          dialog: {
            login: false
          },
          menu: [
            {
              text: 'Profil Saya',
              icon: 'mdi-account-reactivate-outline',
              link: '/profile?menu=profile'
            },
            {
              text: 'Password',
              icon: 'mdi-lock-reset',
              link: '/profile?menu=password'
            }
          ],
  
          form: {},
  
          process: {
            load: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        General: () => import(/* webpackPrefetch: true */ '@/components/profile/general.vue'),
        Password: () => import(/* webpackPrefetch: true */ '@/components/profile/password.vue')
      },
      watch: {
        '$route.query.menu': function(val) {
          this.changeLink(val)
        }
      },
      computed: {
        rps () {
          return this.$vuetify.breakpoint.name
        },
        user () {
          return this.$store.state.user
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      beforeMount () {
        // this.changeLink(this.$route.query.menu)
      },
      mounted () {
        // this.fetchDetail()
        if (this.$route.query.p !== undefined) {
          this.save()
        } else {
          this.dialog.login = true
        }
      },
      methods: {
        async save () {
          this.message.error = ''

          
          const isValid = true
          if (isValid) {
            this.process.form = true

            let form = {
              apps_token: this.$route.query.p.split(' ').join('+'),
              fcm_token: this.$route.query.q.split(' ').join('+'),
              device: "web"
          }

            await post('admin/auth/sso', {
              data: form
            })
            .then(response => {
              let res = response.data

              if (res.status === 200) {
                let user = res.results.data

                let menu = [
                  {
                    title: 'Dashboard',
                    icon: require('@/assets/icon/dashboard.png'),
                    link: '/dashboard',
                    active: true,
                    sub_menu: []
                  },
                  {
                    title: 'Layanan',
                    icon: require('@/assets/icon/information.png'),
                    link: '/layanan',
                    active: false,
                    sub_menu: [
                      {
                        title: 'Kategori Layanan',
                        link: '/layanan-category',
                        active: false
                      },
                      {
                        title: 'Data Layanan',
                        link: '/layanan',
                        active: false
                      }
                    ]
                  },
                  {
                    title: 'Pariwisata',
                    icon: require('@/assets/icon/summer.png'),
                    link: '/pariwisata',
                    active: false,
                    sub_menu: [
                      {
                        title: 'Kategori Pariwisata',
                        link: '/pariwisata/category',
                        active: false
                      },
                      {
                        title: 'Data Pariwisata',
                        link: '/pariwisata',
                        active: false
                      }
                    ]
                  },
                  {
                    title: 'Berita',
                    icon: require('@/assets/icon/media.png'),
                    link: '/berita',
                    active: false,
                    sub_menu: [
                      {
                        title: 'Kategori Berita',
                        link: '/berita/category',
                        active: false
                      },
                      {
                        title: 'Data Berita',
                        link: '/berita',
                        active: false
                      }
                    ]
                  },
                  {
                    title: 'Event',
                    icon: require('@/assets/icon/timetable.png'),
                    link: '/agenda',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Organisasi',
                    icon: require('@/assets/icon/struktur.png'),
                    link: '/structure',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Profil Pejabat',
                    icon: require('@/assets/icon/workers.png'),
                    link: '/profil-pejabat',
                    active: true,
                    sub_menu: []
                  },
                  {
                    title: 'Dokumen',
                    icon: require('@/assets/icon/sheet.png'),
                    link: '/document',
                    active: false,
                    sub_menu: []
                  },
                  // {
                  //   title: 'Unit',
                  //   icon: require('@/assets/icon/struktur.png'),
                  //   link: '/unit',
                  //   active: false,
                  //   sub_menu: [
                  //     {
                  //       title: 'Struktur Organisasi',
                  //       link: '/unit/structure',
                  //       active: false
                  //     },
                  //     {
                  //       title: 'Data Unit / Divisi',
                  //       link: '/unit/division',
                  //       active: false
                  //     },
                  //     {
                  //       title: 'Aturan Organisasi',
                  //       link: '/unit/rule',
                  //       active: false
                  //     }
                  //   ]
                  // },
                  {
                    title: 'User',
                    icon: require('@/assets/icon/man.png'),
                    link: '/user',
                    active: true,
                    sub_menu: []
                  },
                  {
                    title: 'Survey',
                    icon: require('@/assets/icon/rating.png'),
                    link: '/survey',
                    active: true,
                    sub_menu: []
                  },
                  {
                    title: 'Setting',
                    icon: require('@/assets/icon/setting.png'),
                    link: '/setting',
                    active: false,
                    sub_menu: [
                      {
                        title: 'Perusahaan',
                        icon: require('@/assets/icon/company.png'),
                        link: '/setting/company',
                        active: false,
                        sub_menu: []
                      },
                      {
                        title: 'Banner',
                        icon: require('@/assets/icon/slider.png'),
                        link: '/setting/banner',
                        active: false,
                        sub_menu: []
                      },
                      {
                        title: 'Dialog Promosi',
                        icon: require('@/assets/icon/pop-up.png'),
                        link: '/setting/promo',
                        active: false,
                        sub_menu: []
                      }
                    ]
                  }
                ]

                TokenService.saveToken(
                  res.results.token,
                  JSON.stringify(user),
                  JSON.stringify(menu)
                )

                TokenService.saveReload(false)

                window.location = `${process.env.BASE_URL}dashboard`
              } else {
                this.process.form = false
                this.message.error = res.message
                this.dialog.login = true
              }
            })
          }
        },
        toLogin() {
          TokenService.removeToken()
                
          window.location = '/login'
        }
      }
    }
  </script>